import { DeleteIcon, EditIcon } from 'assets/svg'
import { Pagination } from 'components'
import EditCustomerModal from 'components/modal/edit-customer-modal'
import { initFlowbite } from 'flowbite'
import { useEffect, useState } from 'react'
// import { authService } from 'services/auth.services'
import { customersService } from 'services/customers.services'
import { _object } from 'utils/interfaces'

const Customers = () => {
  const [results, setResults] = useState<_object>({})
  const [loading, setLoading] = useState(false)
  const [id, setId] = useState<string>('')

  const [filters, setFilters] = useState<_object>({
    q: '',
    page: 1,
    per_page: 25,
    sort: 'created_at',
    filters: {
      role: '',
      status: ''
    }
  })

  useEffect(() => {
    setLoading(true)
    customersService.getCustomers(filters).then((results: _object) => {
      setResults(results)
      setLoading(false)
    })
  }, [filters])

  // const SendEmail = async (id: string) => {
  //   try {
  //     const res = await authService.sendWelcomeEmail({ id })
  //   } catch (error) {
  //     console.error('Failed to send email', error)
  //   } finally {
  //   }
  // }

  const deleteCustomer = (id: string) => {
    if (window.confirm('Are you sure you want to delete this customer?')) {
      customersService.deleteCustomer(id).then((res: _object) => {
        if (res.error === false) {
          setResults((prev) => ({
            ...prev,
            items: prev.items.filter((item: _object) => item.id !== id),
            pagination: {
              ...prev.pagination,
              total_items: prev.pagination.total_items - 1
            }
          }))
        }
      })
    }
  }

  useEffect(() => {
    initFlowbite()
  })
  return (
    <>

      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center">
          <h1 className="text-2xl font-semibold">
            Customers{' '}
            {results?.pagination?.total_items && (
              <small>Total records: {results?.pagination?.total_items}</small>
            )}
          </h1>
        </div>
        <div className='flex gap-4'>

          <button
            data-modal-target="add-edit-customer-modal"
            data-modal-toggle="add-edit-customer-modal"
            type="button"
            className="px-6 py-2 bg-purple-700 text-white text-sm font-medium rounded-xl shadow-md hover:bg-purple-800 transition-colors"
          >
            Add customer
          </button>

        </div>
      </div>
      <div className="mb-4 flex gap-4">
        <form>
          <div className="flex items-center gap-2">
            <input
              type="search"
              placeholder="Search keyword"
              className="w-60 rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
              value={filters.q || ''}
              onChange={(e) => {
                setFilters({ ...filters, q: e.target.value })
              }}
            />

            <div className="relative w-full">
              <select
                name="status"
                value={filters.filters?.status || ''}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    filters: {
                      ...prev.filters,
                      status: e.target.value
                    }
                  }))
                }
                className="block w-full appearance-none rounded-md border bg-white px-3 py-2 pr-10 text-sm outline-none focus:outline-none"
              >
                <option value="">All status</option>
                {[
                  { key: 'Active', value: 'active' },
                  { key: 'Suspended', value: 'suspended' }
                ].map((item, i) => (
                  <option key={i} value={item.value}>
                    {item.key}
                  </option>
                ))}
              </select>

              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
            <div className="relative w-full">
              <select
                name="role"
                value={filters.filters?.role || ''}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    filters: {
                      ...prev.filters,
                      role: e.target.value
                    }
                  }))
                }
                className="block w-full appearance-none rounded-md border bg-white px-3 py-2 pr-10 text-sm outline-none focus:outline-none"
              >
                {[
                  { key: 'All roll', value: '' },
                  { key: 'Customer', value: 'customer' },
                  { key: 'Admin', value: 'admin' },
                  { key: 'Inventory Manager', value: 'inventory_manager' },
                  { key: 'Customer Support', value: 'customer_support' },
                  { key: 'Logistics Manager', value: 'logistics_manager' }

                ].map((item, i) => (
                  <option key={i} value={item.value}>
                    {item.key}
                  </option>
                ))}
              </select>

              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>

            <button
              type="button"
              className="px-3 py-1 text-sm font-medium whitespace-nowrap text-red-600 underline"
              onClick={() => {
                setFilters({ per_page: 25 })
              }}
            >
              Clear filters
            </button>
          </div>
        </form>
      </div>
      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold">#</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              {/* <th className="px-4 py-3 font-semibold">Company Name</th> */}
              {/* <th className="px-4 py-3 font-semibold"> MYOB Status</th> */}
              <th className="px-4 py-3 font-semibold">Phone Number</th>
              <th className="px-4 py-3 font-semibold">Email</th>
              <th className="px-4 py-3 font-semibold">Role</th>
              <th className="px-4 py-3 font-semibold">Action</th>
              {/* <th className="px-4 py-3 font-semibold">eCommerce Status</th> */}
              {/* <th className="px-4 py-3 text-center font-semibold">Action</th> */}
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {loading === false ? (
              results?.items?.length > 0 &&
              results?.items?.map((item: _object, i: number) => {
                return (
                  <>
                    <tr className="hover:bg-gray-50" key={i}>
                      <td className="px-4 py-3">{i + 1}</td>
                      <td className="px-4 py-3">
                        {item?.full_name === 'null null' ? '' : item?.full_name}
                      </td>
                      {/* <td className="px-4 py-3">{item?.company_name}</td> */}
                      {/* <td className="px-4 py-3">{item?.status}</td> */}
                      <td className="px-4 py-3">{item?.phone_number}</td>
                      <td className="px-4 py-3">{item?.email}</td>
                      <td className="px-4 py-3">{item?.role}</td>
                      <td className="px-4 py-3 flex items-center gap-2">

                        <button
                          data-modal-target="add-edit-customer-modal"
                          data-modal-toggle="add-edit-customer-modal"
                          type="button"
                          onClick={() => setId(item.id)}
                        >
                          <EditIcon />
                        </button>
                        <button
                          type="button"
                          onClick={() => deleteCustomer(item.id)}
                          title="Delete Customer"
                        >
                          <DeleteIcon className="h-[20px] w-[20px]" />
                        </button>
                        {/* <button
                          className="inline-flex items-center justify-center px-4 py-1 text-sm font-medium bg-purple-700 text-white rounded-full hover:bg-purple-800 disabled:opacity-50"
                          onClick={() => SendEmail(item.id)}
                          title="Send Welcome Email"
                          disabled={item?.email_sent || emailLoading === item.id}
                        >
                          {emailLoading === item.id ? (
                            <svg aria-hidden="true" className="inline w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                            </svg>
                          ) : (
                            'Send mail'
                          )}
                        </button> */}
                      </td>
                    </tr>
                  </>
                )
              })
            ) : (
              <tr className="animate-pulse">
                <td className="px-4 py-3">
                  <div className="h-4 w-6 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-32 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-12 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-8 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-24 rounded bg-gray-300"></div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-20 rounded bg-gray-300"></div>
                </td>

              </tr>
            )}
            {results?.items?.length <= 0 &&
              <td colSpan={12} className="text-center py-6 text-gray-500">
                <p>No record found</p>
              </td>
            }
          </tbody>
        </table>
      </div>
      {results?.pagination?.total_pages > 1 && loading === false && (
        <Pagination
          pageCount={results?.pagination?.total_pages}
          current_page={results?.pagination?.current_page}
          onPageChange={(e: _object) => {
            setFilters({ ...filters, page: e.selected + 1 })
          }}
        />
      )}
      <EditCustomerModal id={id} />
    </>
  )
}
export default Customers
